module.exports = __webpack_public_path__ + "img/logo.0cde4b63.png";